export default __webpack_public_path__ + "static/media/KWK.3ebc973a.svg";